// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZbQyF","index":"styles_index__Zdt74"};